export class Employee {
    Id : number;
    Name: string;
    Code: string;
	UserName : string;
    Password : string;
    AreaId : number;
    RegionId : number;
    BranchId : number;
    CountryId : number;
    SaasId :string;
    IsActive:number;
    CompanyId : number;
}
